<template>
  <span>
    <v-tooltip bottom>
      <v-btn
        slot="activator"
        dark
        icon
        small
        flat
        @click.native="dialogIntegracao = !dialogIntegracao"
      >
        <svg class="E_icon customIcon i_action" style="width:18px;height:18px" viewBox="0 0 24 24">
          <path
            fill="#000000"
            d="M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1M14.28,14.08L12.26,16.1C11.66,16.7 10.87,17 10.08,17C9.29,17 8.5,16.7 7.9,16.1C6.7,14.9 6.7,12.95 7.9,11.74L9.15,10.5L9.14,11.06C9.14,11.5 9.21,11.95 9.36,12.37L9.41,12.5L9.04,12.87C8.76,13.15 8.6,13.53 8.6,13.92C8.6,14.32 8.76,14.69 9.04,14.97C9.6,15.53 10.57,15.53 11.13,14.97L13.14,12.96C13.43,12.67 13.58,12.3 13.58,11.91C13.58,11.5 13.43,11.14 13.15,10.86C13,10.71 12.9,10.5 12.9,10.29C12.9,10.08 13,9.88 13.15,9.73C13.45,9.42 14,9.43 14.28,9.73C14.86,10.31 15.18,11.08 15.18,11.9C15.18,12.73 14.86,13.5 14.28,14.08M17.1,11.26L15.85,12.5L15.86,11.94C15.86,11.5 15.79,11.06 15.64,10.64L15.6,10.5L15.96,10.13C16.25,9.85 16.4,9.5 16.4,9.08C16.4,8.69 16.25,8.32 15.97,8.04C15.4,7.47 14.43,7.47 13.87,8.04L11.86,10.05C11.58,10.33 11.42,10.7 11.42,11.1C11.42,11.5 11.57,11.86 11.86,12.14C12,12.29 12.1,12.5 12.1,12.71C12.1,12.93 12,13.13 11.85,13.28C11.7,13.44 11.5,13.5 11.29,13.5C11.09,13.5 10.88,13.43 10.72,13.28C9.5,12.08 9.5,10.12 10.72,8.92L12.74,6.9C13.95,5.7 15.9,5.7 17.1,6.9C17.68,7.5 18,8.26 18,9.08C18,9.9 17.68,10.68 17.1,11.26Z"
          ></path>
        </svg>
      </v-btn>
      <span>Token de integração desta empresa</span>
    </v-tooltip>
    <v-dialog
      persistent
      @keydown.esc="dialogIntegracao == true && dialogConfirmacao == false ? dialogIntegracao = false : ''"
      v-model="dialogIntegracao"
      max-width="500"
    >
      <v-card>
        <v-card-title class="headline darkBlue">
          <small class="white--text">Token</small>
          <v-spacer></v-spacer>
          <v-btn small icon dark @click.native="dialogIntegracao = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <hr>
        <v-card-text>
          <article
            class="fadeInUp"
            v-if="this.page1 && this.nota.item.tknIntegracao && this.nota.item.tknIntegracao.token"
          >
            <small class="token_title">Token:</small>
            <v-layout align-center justify-center row fill-height style="margin-top: -5px;">
              <v-flex xs11>
                <div
                  :id="`fieldToken_${nota.item.cnpj}`"
                  class="white--text blue-grey lighten-2 text-xs-center fieldToken"
                >{{this.nota.item.tknIntegracao.token}}</div>
              </v-flex>
              <v-flex xs1>
                <v-tooltip bottom>
                  <v-btn
                    slot="activator"
                    color="teal"
                    icon
                    small
                    flat
                    @click.native="copyToken(`fieldToken_${nota.item.cnpj}`)"
                  >
                    <svg
                      class="customIcon i_action"
                      style="width:24px;height:24px"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="#000000"
                        d="M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z"
                      ></path>
                    </svg>
                  </v-btn>
                  <span>Copiar Token</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
          </article>
          <article
            class="fadeInUp"
            v-else-if="(this.page1 && !this.nota.item.tknIntegracao) || (this.page1 && !this.nota.item.tknIntegracao.token && !this.nota.item.tknIntegracao.refEmpresa)"
          >
            <div class="token_title text-xs-center">Deseja realizar integração com Motor Fiscal?</div>
          </article>
          <article
            class="fadeInUp"
            v-else-if="this.page1 && this.nota.item.tknIntegracao && this.nota.item.tknIntegracao.refEmpresa"
          >
            <div class="token_title text-xs-center">
              Token de: "{{nota.item && nota.item.razao ? nota.item.razao.split(' ')[0] : ''}}" é o mesmo token de:
              <div
                class="emprRazaoVinculada"
                :title="getRazaoEmprVinculada(nota.item.tknIntegracao.refEmpresa)"
              >{{getRazaoEmprVinculada(nota.item.tknIntegracao.refEmpresa)}}</div>
            </div>
            {{this.buscaToken()}}
            <small class="token_title">Token:</small>
            <v-layout align-center justify-center row fill-height style="margin-top: -5px;">
              <v-flex xs11>
                <div
                  :id="`fieldToken_${nota.item.cnpj}`"
                  class="white--text blue-grey lighten-2 text-xs-center fieldToken"
                >{{this.tknBuscado}}</div>
              </v-flex>
              <v-flex xs1>
                <v-tooltip bottom>
                  <v-btn
                    slot="activator"
                    color="teal"
                    icon
                    small
                    flat
                    @click.native="copyToken(`fieldToken_${nota.item.cnpj}`)"
                  >
                    <svg
                      class="customIcon i_action"
                      style="width:24px;height:24px"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="#000000"
                        d="M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z"
                      ></path>
                    </svg>
                  </v-btn>
                  <span>Copiar Token</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
          </article>
          <article class="fadeInUp" style="margin-top: -15px;" v-else-if="!this.page1 && this.pageVerTokens">
             <v-tooltip bottom>
              <v-btn slot="activator" icon small @click.native="resetDialog()">
                <v-icon color="teal">arrow_back</v-icon>
              </v-btn>
              <span>Voltar</span>
            </v-tooltip>
            <div>
              <v-autocomplete
                v-model="emprVinculoSelecionada"
                :item-text="setLabel"
                :items="getEmpresasComTokensCadastrados()"
                label="Empresas:"
                color="teal"
                class="selectEmprVinculo"
                prepend-icon="location_city"
                no-data-text="Não possui empresas com tokens cadastrados"
                return-object
              ></v-autocomplete>
            </div>
          </article>
          <div class="text-xs-center">
            <v-btn
              small
              :loading="loading"
              :disabled="loading"
              color="dark_blue"
              class="white--text"
              @click="middle()"
            >{{this.nota.item.tknIntegracao && this.nota.item.tknIntegracao.token ? 'Renovar Token' : 'Gerar Token'}}</v-btn>
            <v-tooltip bottom>
              <v-btn
                small
                slot="activator"
                :loading="loading"
                :disabled="loading"
                color="teal"
                class="white--text"
                @click="acaoBtnVinculadas()"
              >{{this.pageVerTokens ? 'Vincular' : 'Tokens existentes' }}</v-btn>
              <span>{{this.pageVerTokens ? 'Vincular com empresa selecionada' : 'Vincular esta empresa com alguma que já possua token' }}</span>
            </v-tooltip>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog @keydown.esc="dialogConfirmacao = false" v-model="dialogConfirmacao" max-width="500">
      <v-card>
        <v-card-title class="headline">
          <small>Confirmar renovação de token</small>
        </v-card-title>
        <hr>
        <v-card-text>
          Token de integração para: "
          <strong>{{nota ? nota.item.razao : ''}}</strong>" será renovado.
          <br>Com isso vem a necessidade de atualizar os ambientes que utilizam o token
          <br>
          <b>Confirmar operação?</b>
        </v-card-text>
        <hr>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="error" small flat="flat" @click="dialogConfirmacao = false">Cancelar</v-btn>

          <v-btn
            small
            color="teal"
            class="white--text"
            @click="gerarToken(), dialogConfirmacao = false"
          >Renovar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>
<script>
import tknService from "@/domain/conta/empresa/token/TokenService";
import EmpresaService from "@/domain/conta/empresa/EmpresaService.js";
export default {
  props: ["conta", "alert", "nota", "empresa", "component", "table"],
  data() {
    return {
      dialogIntegracao: false,
      loader: null,
      loading: false,
      dialogConfirmacao: false,
      page1: true,
      pageVerTokens: false,
      emprVinculoSelecionada: undefined,
      tknBuscado: ""
    };
  },
  methods: {
    buscaToken: function() {
      this.service = new tknService(this.$http);
      this.service
        .buscaToken(this.nota.item._id)
        .then(res => {
          if (res.ok) {
            this.tknBuscado = res.body.token;
          } else {
            this.tknBuscado = "";
          }
        });
    },
    acaoBtnVinculadas: function() {
      if (this.pageVerTokens) {
        if (!this.emprVinculoSelecionada) {
          this.alert.snackDefault();
          this.alert.snack.text = "Necessário selecionar alguma empresa";
          this.alert.snack.show = true;
          return;
        }
        this.loader = "loading";
        this.service = new tknService(this.$http);
        this.service
          .vinculaEmpr(this.nota.item._id, this.emprVinculoSelecionada._id)
          .then(res => {
            if (res.ok) {
              this.attTableEmp();
            } else {
              this.alert.snackSuccess();
              this.alert.snack.text = "Motor fiscal não conseguiu vincular";
              this.alert.snack.show = true;
              this.resetDialog();
              this.limparLoadingBtn();
            }
          });
      } else {
        this.page1 = false;
        this.pageVerTokens = true;
      }
    },
    middle: function() {
      if (this.nota && this.nota.item) {
        if (
          this.nota.item.tknIntegracao &&
          (this.nota.item.tknIntegracao.token ||
            this.nota.item.tknIntegracao.refEmpresa)
        ) {
          this.dialogConfirmacao = true;
        } else {
          this.gerarToken();
        }
      }
    },
    getRazaoEmprVinculada(idEmprVinculada) {
      return this.table.array_todas_notas.filter(empr => {
        if (empr) {
          if (empr._id == idEmprVinculada) {
            return empr;
          }
        }
      })[0].razao;
    },
    copyToken(element) {
      var doc = document;
      var text = doc.getElementById(element);
      if (doc.body.createTextRange) {
        // ms
        var range = doc.body.createTextRange();
        range.moveToElementText(text);
        range.select();
        doc.execCommand("copy");
      } else if (window.getSelection) {
        var selection = window.getSelection();
        var range = doc.createRange();
        range.selectNodeContents(text);
        selection.removeAllRanges();
        selection.addRange(range);
        doc.execCommand("copy");
      } else {
        console.warn("Could not select text in node: Unsupported browser.");
      }
    },
    gerarToken: function() {
      this.loader = "loading";
      this.service = new tknService(this.$http);
      this.service.nvToken(this.nota.item._id).then(res => {
        if (res.ok) {
          this.attTableEmp();
        } else {
          this.alert.snackSuccess();
          this.alert.snack.text =
            "Motor fiscal não conseguiu gerar um novo token";
          this.alert.snack.show = true;
          this.limparLoadingBtn();
        }
      });
    },
    limparLoadingBtn: function() {
      clearInterval(this.timer);
      this.loading = false;
      this.timer = null;
      this.loader = null;
    },
    setLabel(item) {
      return `${item.razao} - 
      ${
        item.cnpj.length > 11
          ? `CNPJ:  ${item.cnpj.replace(
              /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
              "$1.$2.$3/$4-$5"
            )}`
          : item.cnpj.length == 11
          ? `CPF: ${item.cnpj.replace(
              /^(\d{3})(\d{3})(\d{3})(\d{2})/,
              "$1.$2.$3-$4"
            )} `
          : ""
      }`;
    },
    getEmpresasComTokensCadastrados() {
      return this.table.array_todas_notas.filter(empr => {
        if (empr) {
          if (empr.tknIntegracao && empr.tknIntegracao.token) {
            if (!(empr._id == this.nota.item._id)) {
              return empr;
            }
          }
        }
      });
    },
    resetDialog: function() {
      this.page1 = true;
      this.pageVerTokens = false;
      this.emprVinculoSelecionada = undefined;
    },
    attTableEmp: async function(resp) {
      this.service = new EmpresaService(this.$http);
      await this.service.getEmpresasConta(this.conta.conta).then(body => {
        this.table.arrayNotas = [];
        this.table.qnt_total_notas = body.empresas.length;
        this.table.setNota(
          this.table.arrayNotas,
          body.empresas,
          body.faturamento,
          this.table.pagination
        );
        this.table.array_todas_notas = this.table.arrayNotas.slice();
        this.table.setPages(
          this.table.arrayNotas.length,
          this.table.pagination.rowsPerPage
        );

        this.sendAttTable = true;
        this.resetDialog();
        this.alert.snack.text = "Novo token foi gerado";
        this.alert.snackSuccess();

        this.limparLoadingBtn();
        this.alert.snack.show = true;
      });
    }
  },
  watch: {
    dialogIntegracao: function(newV, oldV) {
      this.resetDialog();
    },
    loader() {
      if (this.loader != null) {
        const l = this.loader;
        this[l] = !this[l];

        this.timer = setTimeout(() => (this[l] = false), 20000000);

        this.loader = null;
      }
    }
  }
};
</script>
<style scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
.fieldToken {
  font-size: 0.9em;
  color: #4d627b;
  opacity: 0.75;
  white-space: nowrap;
  width: 100%;
  padding: 3px;
  overflow-x: scroll;
}
.fieldToken::-webkit-scrollbar {
  position: absolute;
  width: 5px;
  height: 5px;
}
.token_title {
  color: #4d627b;
  font-weight: 700;
}
.fieldToken::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.88);
  width: 5px;
  position: absolute;
  top: 0px;
  opacity: 0.8;
  display: block;
  border-radius: 7px;
  z-index: 99;
  right: 1px;
  height: 4px;
  visibility: visible;
}

.emprRazaoVinculada {
  font-size: 0.9em;
  color: #4d627b;
  opacity: 0.75;
  text-overflow: ellipsis !important;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
}
@-webkit-keyframes fadeInUp {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.fadeInUp {
  -webkit-animation-name: fadeInUp;
  animation-name: fadeInUp;
  animation: fadeInUp 0.5s ease-in;
}
</style>



// WEBPACK FOOTER //
// src/components/dataTable/commonTable/coluna_actions/btnLinkIntegracao/LinkIntegracao.vue